import { Image, StyleSheet, View } from '@react-pdf/renderer'
import React from 'react'

interface PdfHeatmapWithLegendProps {
  heatmapSrc: string
  legendSrc?: string
  heatmapHeight?: number
  legendWidth?: number
  gap?: number
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'flex-start',
  },
  centerColumn: {
    flex: 1,
    alignItems: 'center',
  },
  heatmapImage: {
    objectFit: 'contain',
    flexGrow: 0,
    flexShrink: 1,
    alignSelf: 'center',
  },
  legendImage: {
    objectFit: 'contain',
  },
})

export const PdfHeatmapWithLegend: React.FC<PdfHeatmapWithLegendProps> = ({
  heatmapSrc,
  legendSrc,
  heatmapHeight = 240,
  legendWidth = 56,
  gap = 16,
}) => {
  const sideColumnWidth = legendSrc ? legendWidth + gap : 0

  return (
    <View style={styles.row}>
      {legendSrc ? <View style={{ width: sideColumnWidth }} /> : null}
      <View style={styles.centerColumn}>
        <Image
          src={heatmapSrc}
          cache={false}
          style={[styles.heatmapImage, { height: heatmapHeight }]}
        />
      </View>
      {legendSrc ? (
        <View style={{ width: legendWidth, marginLeft: gap }}>
          <Image
            src={legendSrc}
            cache={false}
            style={[
              styles.legendImage,
              { width: legendWidth, height: heatmapHeight },
            ]}
          />
        </View>
      ) : null}
    </View>
  )
}
